import { useState } from "react";
import { Page } from "../components/ui.jsx";
import { ORG } from "../data/org.js";

const initials = (name) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

function OrgCard({ node, color, sub, open, onToggle }) {
  const reports = node.reports || [];
  return (
    <button
      className={"orgcard org-" + color + (sub ? " orgsub" : "")}
      onClick={() => reports.length && onToggle()}
      style={{ cursor: reports.length ? "pointer" : "default" }}
    >
      <span className="orgbar" />
      <span className="orgav">{initials(node.name)}</span>
      <span className="orginfo">
        <span className="orgname">
          {node.name}
          {!sub && node.color && <span className="orgtag">EXEC</span>}
        </span>
        <span className="orgrole">{node.role}</span>
      </span>
      {reports.length > 0 && (
        <span className="orgcount">
          {reports.length} {open ? "▲" : "▼"}
        </span>
      )}
    </button>
  );
}

// Expansion state is keyed by name, so a branch stays open as you nest deeper.
function OrgBranch({ node, color, openMap, setOpenMap, depth }) {
  const open = !!openMap[node.name];
  const reports = node.reports || [];
  return (
    <div className={depth > 0 ? "orgnest" : ""}>
      <OrgCard
        node={node}
        color={color}
        sub={depth > 0}
        open={open}
        onToggle={() => setOpenMap({ ...openMap, [node.name]: !open })}
      />
      {open &&
        reports.map((child, i) => (
          <OrgBranch
            key={child.name + i}
            node={child}
            color={color}
            openMap={openMap}
            setOpenMap={setOpenMap}
            depth={depth + 1}
          />
        ))}
    </div>
  );
}

export default function Org({ back }) {
  const [openMap, setOpenMap] = useState({});

  // Every node that has reports, so "Expand all" can open them in one pass.
  const expandable = [];
  const walk = (node) => {
    if (node.reports && node.reports.length) {
      expandable.push(node.name);
      node.reports.forEach(walk);
    }
  };
  ORG.exec.forEach(walk);

  const expandAll = () => {
    const next = {};
    expandable.forEach((name) => {
      next[name] = true;
    });
    setOpenMap(next);
  };

  return (
    <Page
      back={back}
      eyebrow="SATX Campus"
      title="The org chart."
      intro="Who carries what in the room. Tap any card with a number to open its team."
    >
      <div className="orgdark">
        <div className="orghead">
          <div className="orgeyebrow">The CLLXTV Church · SATX Campus</div>
          <div className="orgtitle">Leadership Structure</div>
          <div className="orgsubline">History. Happens. Here.</div>
          <div className="orgrule" />
        </div>

        <div className="orgbtns">
          <button className="orgbtn" onClick={expandAll}>
            Expand all
          </button>
          <button className="orgbtn" onClick={() => setOpenMap({})}>
            Collapse all
          </button>
          <button className="orgbtn" onClick={() => window.print()}>
            Download
          </button>
        </div>

        <div className="orgroot org-gold">
          <span className="orgav">{initials(ORG.root.name)}</span>
          <span className="orginfo">
            <span className="orgname" style={{ color: "#EEC658" }}>
              {ORG.root.name}
            </span>
            <span className="orgrole">{ORG.root.role}</span>
          </span>
        </div>

        <div className="orgstem" />
        <div className="orgsec">
          <span>Executive Staff</span>
        </div>
        <div className="orgsecnote">{ORG.exec.length} members</div>

        {ORG.exec.map((node) => (
          <OrgBranch
            key={node.name}
            node={node}
            color={node.color}
            openMap={openMap}
            setOpenMap={setOpenMap}
            depth={0}
          />
        ))}

        <div className="orgsec" style={{ marginTop: 28 }}>
          <span>Ministry Leads</span>
        </div>
        <div className="orgsecnote">Direct to Senior Pastor</div>

        {ORG.ministry.map((node) => (
          <OrgCard key={node.name} node={node} color="gold" sub open={false} onToggle={() => {}} />
        ))}

        <div className="orglegend">
          {ORG.legend.map(([key, label]) => (
            <span key={label} className="orgleg">
              <span className={"orgdot orgdot-" + key} /> {label}
            </span>
          ))}
        </div>

        <div className="orgfoot">Tap any card with a number badge to expand the team</div>
      </div>
    </Page>
  );
}
